import { Component, OnInit, OnDestroy, NgZone, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { CompanyModel } from 'src/app/_models/Company/CompanyModel';
import { CompanyService } from 'src/app/company.service';
import { ApiService } from 'src/app/_services/api.service';
import { PromoterGooglePlaceModel } from 'src/app/interfaces/promoter/PromoterGooglePlace.model';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/_services/auth.service';
import { DialogService } from 'primeng/dynamicdialog';
import { CompanyCredentialsComponent } from '../company-credentials/company-credentials.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss']
})
export class CompanyProfileComponent implements OnInit, OnDestroy {
  @ViewChild('search') searchElementRef: ElementRef;

  public company: CompanyModel;
  public companyForm: UntypedFormGroup = new UntypedFormGroup({})
  public businessType: UntypedFormGroup = new UntypedFormGroup({})
  public subscription: Subscription;
  public usersubscription: Subscription;
  public enableEdit: boolean = false;
  public companyTypesString: string = '';
  public list: any[];
  public typesIds: number[] = new Array();
  public companyAdress: PromoterGooglePlaceModel = {};
  public businessTypeIds: string[] = new Array();
  public loading: boolean = false
  public errorModel: { [k: string]: any } = {};
  public invalidInputErrorMessage = "INFO.HQ_ERROR";
  public countryCode: string;

  constructor(
    private companyService: CompanyService,
    private apiService: ApiService,
    private authService: AuthService,
    private ngZone: NgZone,
    public dialogService: DialogService,
    private translate: TranslateService,
  ) {
    authService.hideNavigationMenuEventEmitter.emit(false);
    this.list = [
      { name: 'Cafes and boutiques', checked: false, id: 1 },
      { name: 'Pubs and bars', checked: false, id: 2 },
      { name: 'Restaurants and bistros', checked: false, id: 3 },
      { name: 'Clubs and discotheques ', checked: false, id: 4 },
      // { name:'Halls and galeries', checked: false, id: 5 },
      { name: 'Private and premium clubs', checked: false, id: 6 },
      // { name:'Arenas and malls', checked: false, id: 7 },
      // { name:'Public spaces', checked: false, id: 8 }
    ]
  }


  ngOnInit(): void {
    this.initForm();
    this.fetchCompanyDetails();
    this.getCompanyDetails();
    this.checkIfNeedUpdate();
  }

  ngAfterViewInit() {

  }
  initForm() {
    this.companyForm = new UntypedFormGroup({
      id: new UntypedFormControl('', [Validators.required]),
      companyName: new UntypedFormControl('', [Validators.required]),
      address: new UntypedFormControl('', [Validators.required, Validators.maxLength(255)]),
      city: new UntypedFormControl('', [Validators.required]),
      postalCode: new UntypedFormControl('', [Validators.required]),
      countryCode: new UntypedFormControl('', [Validators.required]),
      taxNumber: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),
      phone: new UntypedFormControl('', [Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$')]),
      websiteUrl: new UntypedFormControl('', [Validators.required]),
      generalManagerId: new UntypedFormControl('', [Validators.required]),
      businessTypesCompanies: new UntypedFormArray([]),
    });

    this.businessType = new UntypedFormGroup({
      id: new UntypedFormControl(0, [Validators.required]),
      name: new UntypedFormControl('', [Validators.required]),
      description: new UntypedFormControl(null),
    });
    this.disableInputsForEditing();
  }
  enableInputsForEditing() {
    this.companyForm.controls['companyName'].enable();
    this.companyForm.controls['websiteUrl'].enable();
    this.companyForm.controls['email'].enable();
    this.companyForm.controls['phone'].enable();
  }
  disableInputsForEditing() {
    this.companyForm.controls['companyName'].disable();
    this.companyForm.controls['websiteUrl'].disable();
    this.companyForm.controls['email'].disable();
    this.companyForm.controls['phone'].disable();
  }

  fetchCompanyDetails() {
    this.usersubscription = this.authService.user.subscribe(user => {
      if (user?.companyId) {
        this.apiService.getCompanyDetails().subscribe(data => {
          this.getCompanyDetails();
          this.setCountryCode();
        })
      }
    })
  }

  getCompanyDetails() {
    this.subscription = this.companyService.companyChanged
      .subscribe((company: CompanyModel) => {
        this.company = company
      })
    this.company = this.companyService.getCompany();
    this.typesIds = new Array();
    this.company?.businessTypesCompanies?.forEach((element: any) => {
      this.typesIds.push(element.id)
    })
    this.companyForm.patchValue({ id: this.company.id })
    this.companyForm.patchValue({ companyName: this.company.companyName })
    this.companyForm.patchValue({ address: this.company.address })
    this.companyForm.patchValue({ city: this.company.city })
    this.companyForm.patchValue({ postalCode: this.company.postalCode })
    this.companyForm.patchValue({ countryCode: this.company.countryCode })
    this.companyForm.patchValue({ taxNumber: this.company.taxNumber })
    this.companyForm.patchValue({ email: this.company.email })
    this.companyForm.patchValue({ phone: this.company.phone })
    this.companyForm.patchValue({ websiteUrl: this.company.websiteUrl })
    this.companyForm.patchValue({ generalManagerId: this.company.generalManagerId })
    this.getBusinesTypesAsString(this.company?.businessTypesCompanies)
    this.disableInputsForEditing();
  }

  checkIfNeedUpdate() {
    if (this.company.needCompanyUpdate) {
      this.companyCredentialsDialog(this.company);
    }
  }

  companyCredentialsDialog(company: CompanyModel) {
    const ref = this.dialogService.open(CompanyCredentialsComponent, {
      data: {
        companyId: company.id
      },
      autoZIndex: false,
      header: this.translate.instant('INFO.COMPANY_INFORMATION'),
      width: '720px'
    });
    ref.onClose.subscribe((success: boolean) => {
      if (success) {
        this.fetchCompanyDetails();
      }
    });
  }

  getBusinesTypesAsString(companyTypes: any) {
    let temp: string[] = [];
    if (companyTypes !== undefined) {
      companyTypes.forEach((element: { name: string; }) => {
        temp.push(element.name)
      });
    }
    this.companyTypesString = temp.join(', ');
  }

  setCountryCode(){
    if(this.company.countryId){
      this.apiService.getallcountrynames().subscribe((countries)=>{
        countries.forEach((element: {countryCode: string; id: string | undefined;}) => {
          if(element.id == this.company.countryId){
            this.countryCode = element.countryCode;
          }
        });
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  showEdit() {
    if (!this.company.needCompanyUpdate) {
      this.enableEdit = true;
      this.enableInputsForEditing();
      this.findAddress();
    } else {
      this.companyCredentialsDialog(this.company);
    }
  }

  save() {
    let data = this.companyForm.value;
    if (data.address != this.company.address) {
      if (Object.keys(this.companyAdress).length == 0) {
        this.errorModel['address'] = this.invalidInputErrorMessage;
      } else {
        this.errorModel['address'] = null;
        data.address = this.companyAdress.placeAddress;
        data.city = this.companyAdress.placeCity;
        data.postalCode = this.companyAdress.placePostalCode;
        data.countryCode = this.companyAdress.placeCountryCode;
      }
    } else {
      data.address = this.company.address;
      data.city = this.company.city;
      data.postalCode = this.company.postalCode;
      data.countryCode = this.company.countryCode;
    }

    if (!this.errorModel['address']) {
      this.loading = true;
      data.businessTypesCompanies = this.typesIds;
      this.apiService.updateCompany(data).subscribe((response) => {
        if (response) {
          this.loading = false;
          // this.companyForm.reset();
          this.enableEdit = false;
          this.disableInputsForEditing();
          this.usersubscription = this.authService.user.subscribe(user => {
            if (user?.companyId) {
              this.apiService.getCompanyDetails().subscribe(data => {
                this.loading = false;
                this.getCompanyDetails();
              })
            }
          })
        }
      });
    }
  }
  cancel() {
    this.enableEdit = false;
    this.errorModel['address'] = null;
    this.getCompanyDetails()
  }

  changeAddress(event: any){
    this.errorModel['address'] = this.invalidInputErrorMessage;
    this.companyAdress = {};
  }

  findAddress() {
    // TODO: need to load Google Maps API first
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement, {
        types: ["address"],
        // componentRestrictions: { country: this.company.countryCode as string },
      });
      if(this.countryCode != undefined){
        autocomplete.setComponentRestrictions({ country: this.countryCode });
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = autocomplete.getPlace();
            this.companyAdress.placeID = place.place_id;
            this.companyAdress.placeName = place.name;
            this.companyAdress.placeAddress = place.formatted_address;

            for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
              const componentType = component.types[0];

              switch (componentType) {
                case "postal_code": {
                  this.companyAdress.placePostalCode = `${component.long_name}`;
                  break;
                }

                case "locality":
                  this.companyAdress.placeCity = `${component.short_name}`
                  break;

                case "country":
                  this.companyAdress.placeCountry = `${component.long_name}`
                  this.companyAdress.placeCountryCode = `${component.short_name}`
                  break;
              }
            }
          })
          this.errorModel['address'] = null;
        })
      }
  }

  shareIndividualCheckedTypeList(item: any) {
    this.typesIds = item
  }

  addBusinessTypesToForm(typesIds: any[]) {
    let checkedList: any[] = [];
    if (typesIds) {
      this.list.map((item) => {
        this.typesIds.map((id) => {
          if (item.id == id) {
            item.checked = true;
            checkedList.push(item);
          }
        })
      }
      );
    }

    const control = <UntypedFormArray>this.companyForm.controls['businessTypesCompanies'];
    control.clear();
    checkedList.forEach(item => {
      this.businessType = new UntypedFormGroup({
        id: new UntypedFormControl(0, [Validators.required]),
        name: new UntypedFormControl('', [Validators.required]),
        description: new UntypedFormControl(null),
      });
      this.businessType.patchValue({ id: item.id })
      this.businessType.patchValue({ name: item.name })
      this.businessType.patchValue({ description: item.description })
      if (item.checked) {
        control.push(this.businessType);
      }
      else {
        control.removeAt(control.value.findIndex((tmp: { id: number; }) => tmp.id === item.id));
      }
    })
  }
  isEmptyObject(obj: any) {
    return (obj && (Object.keys(obj).length === 0));
  }
}
